import * as uuid from 'uuid';

import { COUNTRIES } from '@editor2/containers/PageElementsPage/components/GeoMap/data/countries';
import { STATES } from '@editor2/containers/PageElementsPage/components/GeoMap/data/states';
import { type GeoMapColor, GeoMapType } from '@editor2/types/pageElements';
import {
	DEFAULT_US_SCALE,
	DEFAULT_WORLD_SCALE
} from '@editor2/containers/PageElementsPage/components/GeoMap/constants';
import { worldMapRenamingMapper } from '@editor2/containers/PageElementsPage/components/GeoMap/renamingMapper';

export const colorsToOptions = (colors: GeoMapColor[]) => {
	const options = colors.map(({ name, color, id }) => ({ label: name, value: id }));
	return options.filter(({ label }) => label !== '');
};

export const mergeGeoMapData = (initData, data, labels) => {
	const mergedData = Object.keys(initData).reduce((acc, curr) => {
		const featureName = data[curr] ? curr : worldMapRenamingMapper[curr];

		acc[curr] =
			featureName && data[featureName] ? data[featureName] : Array(labels.length).fill('');
		return acc;
	}, {});

	return mergedData;
};

const compareByName = (a, b) => {
	return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
};

export const getDataByMapType = (mapType: GeoMapType) => {
	switch (mapType) {
		case GeoMapType.US:
			return STATES.sort(compareByName);

		case GeoMapType.World:
			return COUNTRIES.sort(compareByName);

		default:
			break;
	}
};

export const getDefaultScaleByMapType = (mapType: GeoMapType) => {
	switch (mapType) {
		case GeoMapType.US:
			return DEFAULT_US_SCALE;

		case GeoMapType.World:
			return DEFAULT_WORLD_SCALE;

		default:
			break;
	}
};

export const getKeyColumnName = (mapType: GeoMapType) => {
	switch (mapType) {
		case GeoMapType.US:
			return 'State';

		case GeoMapType.World:
			return 'Country';

		default:
			break;
	}
};

export const getGeoMapInitData = (mapType: GeoMapType) => {
	const data = getDataByMapType(mapType);

	return data.reduce((acc, curr) => {
		return { ...acc, [curr.name]: [''] };
	}, {});
};

export const getGeoMapInitLabels = () => {
	return ['Group'];
};

export const getGeoMapInitColors = () => {
	return [{ name: '', color: '#ffffff', id: uuid.v4() }];
};

export const getGeoMapInitMargins = () => {
	return ['0', '10', '25', '10'] as [string, string, string, string];
};

export const getGeoMapTooltipTemplate = (mapType: GeoMapType) => {
	return `[${getKeyColumnName(mapType)}] &mdash; Group: <strong>[Group]</strong>`;
};
